import { createAsyncThunk } from "@reduxjs/toolkit";
import { setAllProducts, setProducts } from "../store/productSlice";
import api from "../../utilis/api";

export const fetchProducts = createAsyncThunk(
  "products/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/products/all");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getProducts = createAsyncThunk(
  "products/getPaginated",
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get("/products", { params });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
